import { defineMessages } from 'react-intl'

const scope =
  'procurify.modules.purchasing.feature-sets.CatalogUserAccessSection'

export default defineMessages({
  selectUserPlaceholder: {
    id: `${scope}.selectUserPlaceholder`,
    defaultMessage:
      'Select a user to manage {singularSecondaryOrgCategoryLabel} access.',
  },
})
